
import { mapActions, mapState, mapGetters } from "vuex";
import { ORDER_READY } from "@/constants/MixpanelEvents.js";
import OrderItemsList from "../reciever/order-items-list.vue";
import OrderRiderDetails from "../reciever/order-rider-details.vue";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: {
    OrderItemsList,
    OrderRiderDetails,
    ResponsiveDialog
  },
  data() {
    return {
      preparationTime: 0,
      acceptLoading: false,
      orderDetailsLoading: false,
      orderDetailObj: {}
    };
  },
  props: {
    dialog: false,
    order: {}
  },
  computed: {
    ...mapGetters("reciever", ["getSelectedChannelNewOrders"]),
    ...mapGetters("restaurant", ["getRecieverSettings"]),
    ...mapState("restaurant", ["printers"])
  },
  mounted() {
    if (this.order && this.order.id) {
      this.orderDetailsLoading = true;
      this.getOrderDetailsObj({
        orderId: this.order.id
      })
        .then((response) => {
          if (response) {
            this.orderDetailObj = response;
          } else {
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.orderDetailsLoading = false;
          this.$refs["action-btn"].$el.focus();
        });
    }
  },
  methods: {
    ...mapActions("reciever", ["getOrderDetailsObj", "patchOrderStatus"]),
    async handleReadyForDelivery() {
      this.acceptLoading = true;
      try {
        const response = await this.patchOrderStatus({
          orderId: this.order.id,
          payload: {
            new_status: "Food Ready"
          }
        });
        if (response.status === 200) {
          this.$emit("order-delivered");
          this.mixPanelTrackEvent(ORDER_READY);
          if (
            this.getRecieverSettings(this.orderDetailObj.restaurant_id)
              .enable_print_bill ||
            (this.getChannelConstObj(this.orderDetailObj.source).name ===
              this.$constants.Channels.WHATSAPP.name &&
              this.getBoolean(this.$ls.get("is-whatsapp-print-bill", false)))
          ) {
            this.$nuxt.$emit(
              "initiate-print",
              this.orderDetailObj,
              "bill",
              false,
              true,
              false,
              false,
              true,
              this.printers[0],
              "orderReadyForDelivery"
            );
          }
        } else {
          this.$nuxt.$emit("show-error-toast", response);
        }
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.acceptLoading = false;
    }
  }
};
